import { useMutation } from "react-query";
import { updateAgencyMapping } from "../../../../../actions/Utilities/AgencyMapping";

const useEditAgencyMapping = () => {
  return useMutation(updateAgencyMapping);
};
export default useEditAgencyMapping;
